import React from 'react';
import LoadingSpinner from './loadingSpinner'
import C18Button00 from './C18Button00'
import C18Anchor00 from './C18Anchor00'
import config from '../../components/utils/config'
import {wsTrans} from '../utils/utils'
import {cl,showTime,globs,constant,dateToYrMoDa,dateToMoDaYrStr,
  getDaysRemaining,dateToDisplayDate} from '../../components/utils/utils';
import {toggleAClass,hasAClass,removeAClass} from '../utils/utils';
import {gitCommitHash,gitBranch} from '../../generatedGitInfo.json'
import {loadUser,loadAlarmsInfo,loadPrivsInfo,getAlarmInfo,alLevel,privs,loadSubscriptionInfo,
  getRecurlyAccount,acctFeature,loadAddedSensorsInfo,loadMBInfo,loadUsersInfo,
  getSuperUserFlags,isTrialPlanCode,getPlanLabel,isAlarmAcknowledged,
} from './C18utils'
// var version="a.b.c"
// cl(version)
class C18MenuBar00 extends React.Component{
  constructor(props) {
    super(props);
//     cl(props)
    this.state={
      loaded: false,
      navClass: " ",
      menuSel:props.parms.mode,
      serverUp:true,
      showSites:false,
      showSub:false,
      syncStatText:"Offline 6m",
      syncStatColor:"#C04040",
      syncStatShow:false,
      menuItems:[
        {v:"sites",t:"Sites"},
//         {v:"reports",t:"Reports and Graphs"},
//         {v:"reports",t:"Graphs"},
//         {v:"editFui",t:"Edit Fui"},
      ],
    }
    let mi=[{v:"sites",t:"Sites"}]
    if(acctFeature("dev")){mi=[{v:"home",t:"Home"}]}
    if(config.server !== "prod0"){
      if(acctFeature("editFui")){mi.push({v:"editFui",t:"Edit Fui"})}
    }
   
    if(acctFeature("tasks")){mi.push({v:"tasks",t:"Tasks"})}
    if(acctFeature("zoneGroups")){
      mi.push({v:"groups",t:"Groups"})
    }
    if(acctFeature("support")){mi.push({v:"support",t:"Support"})}
//     cl(globs)
    // cl(acctFeature("support"))
    mi.push({v:"reports",t:"Reports & Graphs"})
    this.state.menuItems=mi
    
//     if(globs.userData.session.developer){
//         this.state.menuItems=[
//           {v:"home",t:"Home"},
//           ]
//         
//     }else{
//       if(acctFeature("editFui")){{}}
//       if((config.server=="dev")||(config.server=="ryan")||(config.server=="stage")){
//         this.state.menuItems.push(
//           {v:"editFui",t:"Edit Fui"},
//           {v:"tasks",t:"Tasks"},
//           {v:"reports",t:"Reports & Graphs"},
//         )
//       }
//       if((config.server=="alpha")
//         ||(config.server=="prod0")
//         ||(config.server=="demo")
//       ){
//         this.state.menuItems.push(
//   //         {v:"tasks",t:"Tasks"},
//   //         {v:"editFui",t:"Edit Fui"},
//           {v:"reports",t:"Reports and Graphs"}
//         )
//       }
//     }
    this.subscribe_wsServerOK=globs.events.subscribe("wsServerOK",this.wsServerOK)
    this.subscribe_wsSyncStat=globs.events.subscribe("wsSyncStat",
      this.wsSyncStat)
    this.loadInfo()
    this.loadAlarmsInfo=setInterval(this.loadAlarmsInfo,60000)
    this.loadRecurlyInfo=setInterval(this.loadRecurlyInfo,120000) // 2 min
  }
  
  componentWillUnmount=()=>{
    if(this.subscribe_wsServerOK){this.subscribe_wsServerOK.remove()}
    if(this.subscribe_wsSyncStat){this.subscribe_wsSyncStat.remove()}
    clearInterval(this.loadAlarmsInfo)
    clearInterval(this.loadRecurlyInfo)
  }

  componentDidMount=()=>{
    this.restoreMenuFocus()
  }

  componentDidUpdate=()=>{
    this.restoreMenuFocus()
  }

  restoreMenuFocus=()=>{
    let menuFocus=sessionStorage.getItem("mainNavFocus")
    if(!menuFocus){return}
    let modal=document.getElementById("popup")
    // Dialog is open. Try again when it closes so Alarm Log can take focus back.
    if(modal&&modal.getAttribute("aria-hidden")==="false"){
      this.menuFocusRestored=null
      return
    }
    // wide screens show the plan/date; narrower screens show the R icon
    if(menuFocus==="header-sites-icon"){menuFocus="header-subscription"}
    let menuLink=null
    if(menuFocus==="header-alarm-button"||menuFocus==="header-subscription"){
      let nodes=document.querySelectorAll(`[data-main-nav-focus="${menuFocus}"]`)
      menuLink=Array.from(nodes).find(n=>n.getClientRects().length)||nodes[0]
    }else if(menuFocus){
      menuLink=menuFocus.indexOf("header-")===0
        ?document.getElementById(menuFocus)
        :document.getElementById(`/mainNav/${menuFocus}`)
    }
    if(!menuLink){return}
    let active=document.activeElement
    if(active===menuLink){
      this.menuFocusRestored=menuFocus
      return
    }
    // Wide and narrow copies share one target. Follow the copy that is on screen.
    let sameTarget=active&&active.getAttribute&&(
      active.getAttribute("data-main-nav-focus")===menuFocus||
      active.id===menuFocus||
      active.id===`/mainNav/${menuFocus}`
    )
    if(sameTarget){
      menuLink.focus()
      this.menuFocusRestored=menuFocus
      return
    }
    // Sync status re-renders this bar every second. Focusing again closes selects.
    if(this.menuFocusRestored===menuFocus){return}
    if(active&&active!==document.body&&active!==document.documentElement){
      this.menuFocusRestored=menuFocus
      return
    }
    menuLink.focus()
    this.menuFocusRestored=menuFocus
  }
  
  wsServerOK=(ok)=>{
    this.setState({serverUp:ok})
  }

  wsSyncStat=(cmd)=>{
//     cl(cmd)
    let zoneId=globs.userData.session?.zoneId
    let zone=(globs.zonesInfo?.info||[]).filter(z=>{return z.zoneId==zoneId})[0]

//     cl("sync")
    this.setState({
      syncStatText:cmd.text,
      syncStatColor:cmd.color,
      syncStatShow:zone?.gatewayType==1900
    })

  }
  
  loadAlarmsInfo=async()=>{
//     cl("load alarms info")
    globs.alarmsInfo.got=false
    await loadAlarmsInfo()
    let notificationCount=await this.loadNotificationCount()// was await
    this.setState({update:(this.state.update||0)+1,notificationCount:notificationCount})
  }

  loadRecurlyInfo=async()=>{
//     cl("load recurly info")
    globs.subscriptionInfo.got=false
    await loadSubscriptionInfo()
    let days = getDaysRemaining(new Date(globs.subscriptionInfo.info?.end_date))
    let onTrial = isTrialPlanCode(globs.subscriptionInfo.info?.plan_code) && (days >= 0)
//     cl([days, onTrial])
    this.setState({days: days, onTrial: onTrial})
  }
  
  loadInfo=async()=>{
//     cl(this.props)
//     cl(this.state)
    showTime("menu1a")
    await loadUser();
    showTime("menu1b")
    await loadAlarmsInfo()
    showTime("menu1c")
    await loadAddedSensorsInfo()
    showTime("menu2")
//     cl("loaded added sensors")
    await loadPrivsInfo()
    await loadSubscriptionInfo()
    showTime("menu3a")
    await loadMBInfo()
    showTime("menu3b")
    await loadUsersInfo()
    showTime("menu3c")
    let notificationCount=await this.loadNotificationCount()
    showTime("menu4a")
    // load subscription account (for billing) and days remaining
    let account = await getRecurlyAccount()// 6 seconds
    showTime("menu4b")
    let days = getDaysRemaining(new Date(globs.subscriptionInfo.info?.end_date))
    showTime("menu4c")
    let onTrial = isTrialPlanCode(globs.subscriptionInfo.info?.plan_code) && (days >= 0)
    showTime("menu5")
//     cl(globs.alarmsInfo)
    this.setState({loaded: true,notificationCount: notificationCount, account: account, days: days, onTrial: onTrial})
    showTime("menu6")
  }
  
  mobile_menu_button_click=()=>{
    let curClass=toggleAClass(this.state.navClass,"mobile-menu-triggered")
    this.setState({navClass:curClass})
  }
  
  onClick=(e,type)=>{
    // cl(type)
    if(["sites","tasks","reports","editFui","groups","support"].includes(type)){
      // check if mobile menu is open, then close
      let obj = {menuSel: type}
      let hasClass=hasAClass(this.state.navClass,"mobile-menu-triggered")
      if (hasClass) {
        let curClass=removeAClass(this.state.navClass,"mobile-menu-triggered")
        Object.assign(obj, {navClass:curClass})
      }
//       cl(obj)
      this.setState(obj)
    }
//     cl(type)
    if(this.props.parms){
      if(["sites","tasks","reports","editFui","groups","support"].includes(type)){
        sessionStorage.setItem("mainNavFocus",type)
        this.menuFocusRestored=null
      }else if(type==="subscription"){
        sessionStorage.setItem("mainNavFocus","header-subscription")
        this.menuFocusRestored=null
      }else if(type==="alarms"){
        sessionStorage.setItem("mainNavFocus","header-alarm-button")
        this.menuFocusRestored=null
      }else if(type==="settings"){
        sessionStorage.setItem("mainNavFocus","header-settings-icon")
        this.menuFocusRestored=null
      }
      this.props.parms.onChange({cmd:type})
    }
    e.preventDefault()
//     cl(type)
  }

  handleHeaderIconKeyDown=(e,onActivate)=>{
    sessionStorage.removeItem("mainNavFocus")
    if(e.key==="Enter"||e.key===" "){
      e.preventDefault()
      onActivate()
    }
  }
  
  loadNotificationCount=async()=>{
    showTime("loadNotificationCount1")
    let userId=globs.userData?.session?.userId
    if(!userId){return 0}
    let res=await wsTrans("usa", {cmd: "cRest", uri: "/s/messages", method: "retrieve", 
      sessionId: globs.userData.session.sessionId,
      body: {
        query:{recipientId:userId},
        skip:0,
        limit:10,
      }})
    let msgs=res.data
//     cl(msgs)
    showTime("loadNotificationCount2")
    let notes=await wsTrans("usa", {cmd: "cRest", uri: "/s/notifications",
      method: "retrieve", sessionId: globs.userData.session.sessionId,
      body: {
        userId:userId,
      }})
    notes.data.forEach(no=>{
      msgs.push({userId:-1,flags:no.flags})
    })
//     cl(notes)
//     cl(msgs)
    let msgs2=msgs.filter(msg=>{
      return ((msg.flags||0)&constant.CHAT_FLAG_UNREAD)/*&&(msg.userId!=userId)*/
    })
//     cl(msgs2)
//     cl(msgs)
    showTime("loadNotificationCount3")
    return msgs2.length
//     return 4
  }
  
  showDevHeader=(userName,path)=>{
    let mobile = (window.ReactNativeWebView || (window.innerWidth < 460))
    cl(mobile)
    return(
      <header id="main-header">
        { !mobile &&
        <div id="main-logo">
          <img src="/link4.png" alt="Link4 Controls logo"/>
        </div>
        }
        <div id="mobile-menu-button-container">
          <C18Button00 type="button" id="mobile-menu-button"
            aria-label={hasAClass(this.state.navClass,"mobile-menu-triggered")?"Close main menu":"Open main menu"}
            aria-expanded={hasAClass(this.state.navClass,"mobile-menu-triggered")?"true":"false"}
            onClick={this.mobile_menu_button_click}>
            <span></span>
            <span></span>
            <span></span>
          </C18Button00>
        </div>
        {this.state.serverUp&&
          <nav id="main-nav" className={this.state.navClass} aria-label="Main">
            {this.state.menuItems.map((m,i)=>{
              let cn=(m.v==this.state.menuSel)?"current-menu-item":""
              return(
                <C18Anchor00 id={`/mainNav/${m.v}`} to="" key={i} className={cn}
                  aria-current={(m.v==this.state.menuSel)?"page":undefined}
                  onClick={(e)=>this.onClick(e,m.v)}
                  onKeyDown={e=>{
                    if(e.key!=="Enter"&&e.key!==" "){sessionStorage.removeItem("mainNavFocus")}
                  }}>{m.t}</C18Anchor00>
              )
            })}
          </nav>
        }
        <div id="header-notifications" >
          <C18Anchor00 to="" id="user-name" onClick={o=>{this.onClick(o,"user")}}>{userName}</C18Anchor00>
          <C18Anchor00 to="" id="header-portrait" aria-label={`${userName}, user profile`}
            onClick={e=>this.onClick(e,"user")}>
            <img src={path} alt=""/>
          </C18Anchor00>
        </div>
      </header>
      
    )
    
  }

  showSyncStatus=()=>{
//         <div style={{height:"auto",margin:"auto",display:"inline-block"}}>
//         </div>
//         <div style={{position:"relative",verticalAlign:"middle"}}>
//         </div>
    let st=this.state
    return(
      <div style={{margin:10,padding:10,backgroundColor:st.syncStatColor,
        color:"white",fontSize:"16px",borderRadius:20,minWidth:150,
        textAlign:"center",display:(st.syncStatShow)?"block":"none",
//         display:"table-cell",
//         verticalAlign:"middle",
        fontWeight:700}}>
        {st.syncStatText}
      </div>
    )
  }

  showAiRecord=()=>{
//     cl(config)
//     cl(globs)
//     cl(globs.user.userId)
//     cl(this.props)
//     cl(this.state)
    if((config.server!="stage")&&// TESTING
      (globs.user.userId!="B19CKyZnHqIlqRck")){return}
//     let st=this.state
//     cl("show ai")
    let path=`${constant.expressUrl}/usa/images/icons/record.png`
    return(
      <img alt="Record AI" role="button" tabIndex={0} style={{width:32,height:32}} src={path}
      onClick={e=>{this.props.parms.onChange({cmd:"recordAiIcon",e:e})}}
      onKeyDown={e=>this.handleHeaderIconKeyDown(e,()=>this.props.parms.onChange({cmd:"recordAiIcon",e}))}
      />
    )
  }
  
  showHeader=()=>{
//     cl("showHeader")
//     cl(globs)
    // cl(globs.userData.session?.userId)
    // cl(globs.usersInfo.info)
    let gotUser= globs.userData.session?.userId && globs.usersInfo.info && (globs.usersInfo.info.filter(u=>{
      return u.userId==globs.userData.session.userId}).length!=0)
//     cl(gotUser)
    let userOpac=1
    let userTitle=globs.user.name
    if(!gotUser){
      userOpac=0.5
      userTitle="User is not in this account"
    }
//     cl(globs.userData.session)
    let dark=((globs.device?.deviceTheme||"").toLowerCase().indexOf("dark")>=0)?1:0
    let userName=globs?.user?.name||"Unknown User"
    let av=globs?.user?.avatar
    var path
    if(av){
      path=`${constant.expressUrl}/usa/images/avatars/uploads/${av[0]}/${av[1]}/${av[2]}/${av.substr(3)}.jpeg`
    }else{
      path=`${constant.expressUrl}/usa/images/avatars/stockAvatar.jpg`
    }
    if(globs.userData?.session?.developer){return this.showDevHeader(userName,path)}
//     cl(globs.user)
//     cl(globs.alarmsInfo.info)
    let alarmCount=0
//     cl(globs.alarmsInfo)
//     cl(globs.privsInfo.info)
//     cl(globs.zonesInfo.sz2z)
    globs.alarmsInfo.info.forEach(a=>{
//       cl(globs.zonesInfo)
//       cl(a)
//       cl(a)
      if(globs.zonesInfo.sz2z&&
        globs.zonesInfo.sz2z[a.s] &&
        globs.zonesInfo.sz2z[a.s][a.z] &&
        !globs.zonesInfo.sz2z[a.s][a.z].virtual){
// this seems like *way* too much work to figure the privs just to count the alarms
// disabled 20240212
        let pr=true||privs("zone",(globs.zonesInfo.sz2z[a.s][a.z]||{}).zoneId,constant.AREA_PRIVS_READ)
//         cl(a.a,a.s,a.z)
        let ai=getAlarmInfo(a.a,a.s,a.z)
//         cl(ai)
        if(pr&&((ai.level<4))&&!isAlarmAcknowledged(a)){//(ai.enable!=0)&&  count only UNACKNOWLEDGED urgent (level 1-3)
//           cl(a)
//           if(a.a=="inTLoSa"){cl(a)}

          alarmCount+=1

        }
      }
    })
//     let alarmCount=globs.alarmsInfo.info.length
//     alarmCount=0
    let sst=this.props.parms.siteStatus
//     cl(sst)
    let siteDownCount=0
//     let expDate=dateToMoDaYrStr(new Date(globs.subscriptionInfo.info.end_date))
    let expDate=dateToDisplayDate(new Date(globs.subscriptionInfo.info?.end_date),"yyyy-mm-dd")
    // cl(globs.device)
//     cl(this.state)
    let siteInfo=Object.keys(sst).map((k,i)=>{
      let s=sst[k]
//       cl(s.connected)
      if(!s.connected){siteDownCount++}
      return(
        <tr key={i}>
        <td>{s.name}</td><td>{(s.connected)?"Connected":"Down"}</td>
        </tr>
      )
    })
//     let siteInfo=siteDowns.map(s=>{
//     })
//     cl(siteDowns)
    // get plan name, expiration/renewal date
    let planCode = globs.subscriptionInfo.info?.plan_code
    let name = isTrialPlanCode(planCode)
      ? getPlanLabel(planCode, this.state.onTrial)
      : (globs.subscriptionInfo.info?.add_ons?.annual) ? "Annual" : "Monthly"
    if (this.state.account && this.state.account.hasPastDueInvoice) {
      name += "-Past Due"
    }
    let dateStyle = (isTrialPlanCode(planCode) && this.state.days < 15) 
      ? "grow-journal-tag power subscription" : ""
    let subInfo= [
      <tr key={1}>
      {false&&<td>{"Current Plan: "}</td>}
        <td className="grow-journal-tag equipment subscription">{name}</td>
      </tr>
      ,
      <tr key={2}>
      {false&&<td>{(isTrialPlanCode(planCode) || !globs.subscriptionInfo.info?.auto_renew) ?
        "End Date: " : "Renewal Date: "}</td>}
        <td className={dateStyle}>{expDate}</td>
      </tr>  
      ]
    let showSuper=false&&privs("super","",constant.AREA_PRIVS_READ)
//     let notificationCount=await this.loadNotificationCount()
    let showAdmin=(privs("account",0,constant.AREA_PRIVS_ADMIN)!=0)
    // sub permissions
    let showSub=(privs("account",0,constant.AREA_PRIVS_ADMIN)!=0)
    let mobile = (window.ReactNativeWebView || (window.innerWidth < 460))
    let menuOpen=hasAClass(this.state.navClass,"mobile-menu-triggered")
    let dateKind=(isTrialPlanCode(planCode) || !globs.subscriptionInfo.info?.auto_renew)
      ? "end date" : "renewal date"
    let subLabel=`Manage Subscription, ${name}, ${dateKind} ${expDate}`
    if(this.state.account && !this.state.account.billingInfo){
      subLabel+=", billing information needed"
    }
    let alarmLabel=(alarmCount==1) ? "Alarm Log, 1 unacknowledged alarm"
      : (alarmCount>1) ? `Alarm Log, ${alarmCount} unacknowledged alarms`
      : "Alarm Log"
//     cl(globs.version)
    let tight={marginTop:-5}
    return(
      <header id="main-header">
        { !mobile &&
        <div id="main-logo"
          style={{flexDirection:"column",fontSize:10,color:"#004080"}}
        >
          <div>
            <img src="/link4.png" alt="Link4 Controls logo"/>
          </div>    
          {(getSuperUserFlags() & constant.SUPER_PRIVS_EDIT) !== 0 && (
          <div id='version-info'>
             <div id="appVersion">v{globs.version}</div>
             <div id="appCommit" style={tight}>{gitCommitHash}</div>
             <div id="appBranch" style={tight}>{gitBranch}</div>
           </div>
          )}
        </div>
        }
        <div id="mobile-menu-button-container">
          <C18Button00 type="button" id="mobile-menu-button"
            aria-label={menuOpen?"Close main menu":"Open main menu"}
            aria-expanded={menuOpen?"true":"false"}
            onClick={this.mobile_menu_button_click}>
            <span></span>
            <span></span>
            <span></span>
          </C18Button00>
        </div>
        {this.state.serverUp&&
          <nav id="main-nav" className={this.state.navClass} aria-label="Main">
            {this.state.menuItems.map((m,i)=>{
              let cn=(m.v==this.state.menuSel)?"current-menu-item":""
              return(
                <C18Anchor00 id={`/mainNav/${m.v}`} to="" key={i} className={cn}
                  aria-current={(m.v==this.state.menuSel)?"page":undefined}
                  onClick={(e)=>this.onClick(e,m.v)}
                  onKeyDown={e=>{
                    if(e.key!=="Enter"&&e.key!==" "){sessionStorage.removeItem("mainNavFocus")}
                  }}>{m.t}</C18Anchor00>
              )
            })}
          </nav>
        }
        {!this.state.serverUp&&
          <nav id="main-nav" className={this.state.navClass} aria-label="Main">
          <span style={{backgroundColor:"red", color:"white", paddingLeft:50, paddingRight:50}}>Server Down</span>
          </nav>
        }
        <div id="header-notifications" >
          {/* {acctFeature("messaging")&&
            <div id="header-alarm"
              className={(this.state.notificationCount>0)?"alarm-on":null}>
              <div id="header-notify-icon" className="material-icons"
              onClick={e=>this.props.parms.onChange({cmd:"notifyIcon"})}>message</div>
              {(this.state.notificationCount>0)&&
                <div id="alarm-number">{this.state.notificationCount}</div>
              }
            </div>
          } */}
          {!mobile && this.showAiRecord()}
          {/* hide on mobile */}
          {!mobile && this.showSyncStatus()}
          {showSuper&&
            <div id="header-alarm" style={{position:"relative"}}>
              <div id="header-alarm-icon" title="Super User">
              <img id="/menu/superUser" src={`${constant.expressUrl}/usa/images/icons/sm.png`}/>
              </div>
            </div>
          }
          {true&&
            <C18Anchor00 to="" id="header-alarm" className={"alarm-on sub-section"} style={{position:"relative"}}
              aria-label={subLabel}
              data-main-nav-focus="header-subscription"
              onClick={e=>this.onClick(e,"subscription")}
              onKeyDown={e=>this.handleHeaderIconKeyDown(e,()=>this.onClick(e,"subscription"))}
            >
              <table aria-hidden="true"><tbody>
                {subInfo}
              </tbody></table>
              {(this.state.account && !this.state.account.billingInfo)&&
                <div id="alarm-number" translate="no" aria-hidden="true">!</div>
              }
            </C18Anchor00>
          }
          {true &&
            <C18Anchor00 to="" id="header-alarm" className={"alarm-on sub-icon header-Ricon"}
              aria-label={subLabel}
              data-main-nav-focus="header-subscription"
              onClick={e=>this.onClick(e,"subscription")}
              onKeyDown={e=>this.handleHeaderIconKeyDown(e,()=>this.onClick(e,"subscription"))}
            >
              <div id="header-sites-icon" translate="no" aria-hidden="true">R</div>
              {(this.state.account && !this.state.account.billingInfo)&&
                <div id="alarm-number" translate="no" aria-hidden="true">!</div>
              }
            </C18Anchor00>
          }
          {false&&
            <div id="header-alarm" className={(siteDownCount)?"alarm-on":""} style={{position:"relative"}}
              onClick={e=>this.onClick(e,"alarms")}
            >
              <div id="header-sites-icon"
                onMouseOver={e=>this.setState({showSites:true})}
                onMouseOut={e=>this.setState({showSites:false})}
              >S</div>
              {(siteDownCount>0)&&
                <div id="alarm-number">{siteDownCount}</div>
              }
              <div className={"gateway-status"} style={{display:(this.state.showSites)?"block":"none",
                position:"absolute",backgroundColor:(dark)?"black":"white",width:300,padding:20,borderRadius:10
              }}>
              <table><tbody>
                {siteInfo}
              </tbody></table>
              </div>
            </div>
          }
          {true&&
            <C18Anchor00 to="" id="header-alarm" className={(alarmCount)?"alarm-on":""}
              aria-label={alarmLabel}
              data-main-nav-focus="header-alarm-button"
              onClick={e=>this.onClick(e,"alarms")}
              onKeyDown={e=>this.handleHeaderIconKeyDown(e,()=>this.onClick(e,"alarms"))}
            >
              <div id="header-alarm-icon" translate="no" aria-hidden="true">!</div>
              {(alarmCount>0)&&
                <div id="alarm-number" aria-hidden="true">{alarmCount}</div>
              }
            </C18Anchor00>
          }
          <C18Button00 type="button" id="header-alarm"
            style={{position:"relative",font:"inherit",borderRadius:0,lineHeight:"normal",minWidth:0,minHeight:0,padding:0,background:"transparent",border:"none"}}
            aria-label="Help"
            onClick={e=>this.props.parms.onChange({cmd:"helpIcon", e})}
            onKeyDown={e=>this.handleHeaderIconKeyDown(e,()=>this.props.parms.onChange({cmd:"helpIcon", e}))}
          >
            <div id="header-info-icon" title="Help" aria-hidden="true">
              <img id="/menu/info" alt="" style={{backgroundColor:(dark)?"black":"white", width:"24px"}}
              src={`${constant.expressUrl}/usa/images/icons/help.png`}/>
            </div>
          </C18Button00>

          {showAdmin&&
            <C18Anchor00 to="" id="header-settings-icon" className="material-icons"
              aria-label="Admin Settings"
              onClick={o=>{this.onClick(o,"settings")}}
              onKeyDown={e=>{
                if(e.key!=="Enter"&&e.key!==" "){sessionStorage.removeItem("mainNavFocus")}
              }}
              translate='no'><span aria-hidden="true">settings</span></C18Anchor00>
          }
          {false&&
            <C18Anchor00 to="" id="user-name" onClick={o=>{this.onClick(o,"user")}}>{userName}</C18Anchor00>
          }
          <C18Anchor00 to="" id="header-portrait"
            aria-label={gotUser?`${userName}, user profile`:"User is not in this account"}
            onClick={e=>{
            if(gotUser){this.onClick(e,"user")}else{e.preventDefault()}
          }}>
            <img src={path} alt="" title={userTitle} style={{opacity:userOpac}}/>
          </C18Anchor00>
        </div>
      </header>
    )
  }
  
  render(){
//     cl(this.state)
    if(this.state.loaded){
      return this.showHeader()
    }else{
      return <LoadingSpinner message="loading menu..." />
    }
  }
}

export default C18MenuBar00;
